import axios from 'axios'
import store from './store/index'
import router from './router'

axios.defaults.baseURL = process.env.NODE_ENV === 'production'
  ? 'https://api.liveabc.com/v1'
  : 'https://apitest.liveabc.com/v1'
axios.defaults.timeout = 40000

const excludedUrls = [
  '/login',
  '/barcode_check',
  // '/product',
  // '/products',
  '/register',
  '/password/email',
  '/events'
]

axios.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem('authToken')

    const isExcluded = excludedUrls.some(url => request.url.includes(url))

    if (token && !isExcluded) {
      request.headers.common['Authorization'] = `Bearer ${token}`
    }

    axios.defaults.withCredentials = false
    return request
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => {
    const { error } = response.data

    if (error) {
      const url = response.config.url

      // 避免對 /logout 的回應再觸發 logout
      if (url === '/logout') return response

      switch (error) {
        case 'Token not provided':
          store.dispatch('logout')
          router.push({ name: 'login' })
          break
        case 'TOKEN_EXPIRED':
          store.dispatch('refreshToken')
          break
        case 'TOKEN_INVALID':
          store.dispatch('logout')
          router.push({ name: 'login' })
          break
      }
    }

    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)
